// Svelte-free by design, so a `node:test` file can exercise it.

/** Il codice che significa "nessun canale SdI": recapito via PEC o area riservata. */
const CODICE_DESTINATARIO_NONE = '0000000';

/**
 * Vero quando la mancata consegna è l'esito previsto, non un problema.
 *
 * Copia speculare di isExpectedMancataConsegna() in
 * src/domain/expected-mancata-consegna.js: il frontend non può importare codice
 * del backend, e test/frontend-expected-mancata-consegna.test.js tiene allineate
 * le due versioni.
 *
 * Una fattura a privati o aziende (FPR12) con codice destinatario `0000000` e
 * senza PEC non dà allo SdI alcun canale su cui recapitarla: lo SdI la mette
 * nell'area riservata del cliente e la fattura è emessa e valida. Ogni altra
 * mancata consegna, compresa quella di una fattura dal formato sconosciuto,
 * resta da controllare.
 *
 * @param {{ status?: string, formatoTrasmissione?: string|null,
 *   codiceDestinatario?: string|null, pecDestinatario?: string|null }|null|undefined} invoice
 * @returns {boolean}
 */
export function isExpectedMancataConsegna(invoice) {
  return invoice?.status === 'notifica_mancata_consegna'
    && invoice.formatoTrasmissione === 'FPR12'
    && (invoice.codiceDestinatario || CODICE_DESTINATARIO_NONE) === CODICE_DESTINATARIO_NONE
    && !invoice.pecDestinatario;
}
